import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { CrearPrePedido, BuscarCarritoPedido } from '../../store/sagas/carritoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import Alert from 'sweetalert2';
import ModalSinStock from "../reusable/modals/SinStock";
import Spinner from "../reusable/Loader";

export class CarritoMedioPago extends Component {
  static displayName = CarritoMedioPago.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      medioPago: data.MedioPago.Deposito,
      locales: [],
      alertas: [],
      local: {},
      datosTotal: {},
      productos: [],
      datosLocal: {},
      localId: 0,
      pedidoId: 0,
      addStock: false,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      alertOptions: null,
      listaBancos: [],
      transportista: {}
    };
  }
  IrEnvio = async () => {
    this.props.history.push('/carrito-envio');
  }
  showCarrito = () => {
    this.setState({ addStock: false, loading: false }, () => {
      this.props.history.push({ pathname: '/carrito', params: { datosBuscador: { localId: 0 } } });
    });
  }
  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      let _datosTotal = state.datosTotal;
      let _datosLocal = state.datosLocal;
      console.log("MedioPago====>", state);
      this.setState({
        datosTotal: _datosTotal,
        datosLocal: _datosLocal,
        medioPago: data.MedioPago.Deposito,
        // pedidoId: state.pedidoId,
        localId: state.localId,
        transportista: state.transportista
      });

    }
  }
  load = async (carritoProdctos, setcarritoProdctos) => {
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({
      medioPago: data.MedioPago.Deposito,
      loading: true,
      dealer: result.dealer,
      linea: result.linea,
      asociado: result.asociado,
      addStock: false
    }, () => {
      this.postBuscarCarritoPedido(carritoProdctos, setcarritoProdctos);
    });
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      const auth = this.context;
      this.load(auth.carritoProdctos, auth.setcarritoProdctos);
      this.checkParams();
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { medioPago, datosTotal, alertas, loading } = this.state;
    const auth = this.context;
    console.log("Medio Pago auth", auth.mostrarOfertas);
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1><SvgAssets icon="icon-pago" fill='#fff' />Medio de Pago</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li><Link to='/carrito'>Carrito de compras</Link></li>
              {(auth.mostrarOfertas) ?
                <li><Link to={{ pathname: '/carrito/ofertas', state: { datosTotal: this.state.datosTotal, datosProductos: this.state.productos, localId: this.state.localId } }}>Ofertas</Link></li>
                : null}
              <li><Link to='/carrito/envio'>Envío</Link></li>
              <li><Link to='/carrito/transportistas'>Transportista</Link></li>
              <li>Medio de Pago</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            <SvgAssets icon="icon-pago" fill="#fff" />Medio de pago
          </h6>
          <div className="card container_1000">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="cards-wrap" style={{ maxWidth: 680, margin: 'auto' }}>
              <div className="card_medio_pago">
                <div className="custom-control custom-radio">
                  {(medioPago == data.MedioPago.Deposito) ?
                    <input type="radio" id="radio1" name="radio_mp" className="custom-control-input"
                      checked="checked"
                      onClick={() => this.seleccionarMedioPago(data.MedioPago.Deposito)}
                    /> :
                    <input type="radio" id="radio1" name="radio_mp" className="custom-control-input"
                      onClick={() => this.seleccionarMedioPago(data.MedioPago.Deposito)}
                    />}
                  <label className="custom-control-label" htmlFor="radio1"></label>
                </div>
                <div className="cphTextCenter">
                  <h6 className="paragraph-2 bold" style={{ color: c.azulClaro }}>Pago - DEPÓSITO</h6>
                  <p>Puedes realizar tu pago en los siguientes bancos: </p>
                  <div className="banco-img" >
                    <img src={require('../../assets/img/Bcp_logo.png')} />
                    <img src={require('../../assets/img/Scotiabank_logo.png')} />
                    <img src={require('../../assets/img/BBVA_logo.png')} />
                  </div>
                  <p>Recuerda realizar el pago con el número de pedido y hasta la fecha estimada que te brindaremos en la siguiente página.</p>
                </div>
              </div>
              <div className="card_medio_pago">
                <div className="custom-control custom-radio">
                  {(medioPago == data.MedioPago.PrePedido) ?
                    <input type="radio" id="radio2" name="radio_mp" className="custom-control-input"
                      checked="checked"
                      onClick={() => this.seleccionarMedioPago(data.MedioPago.PrePedido)}
                    /> :
                    <input type="radio" id="radio2" name="radio_mp" className="custom-control-input"
                      onClick={() => this.seleccionarMedioPago(data.MedioPago.PrePedido)}
                    />}
                  <label className="custom-control-label" htmlFor="radio2"></label>
                </div>
                <div className="cphTextCenter">
                  <h6 className="paragraph-2 bold" style={{ color: c.azulClaro }}>Guardar Pre-Pedido</h6>
                  <p>Tu Pre-Pedido quedará guardado por 2 días hábiles, luego será eliminado.</p>
                  <p>Recuerda que este pre-pedido podrás encontrarlo en el menú “Pre-Pedidos”</p>
                </div>
              </div>
            </div>
            {datosTotal.moneda == null || datosTotal.moneda == undefined ? null :
              <p className="total-price">TOTAL: {datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</p>
            }

            {/* <Link to="/carrito-resumen-pedido" style={{ textDecoration: 'none' }}> */}
            <button className={`btn-block mobile${(medioPago == null || datosTotal.total <= 0 ? " disabled" : "")}`}
              type="button"
              disabled={medioPago == null || datosTotal.total <= 0}
              onClick={() => this.postMedioPago(auth.setcarritoProdctos)}
            >siguiente</button>
            {/* </Link> */}
          </div>
          <div className="text-center desktop mt-5">
            <button className={`btn-block${(medioPago == null || datosTotal.total <= 0 ? " disabled" : "")}`}
              type="button"
              disabled={medioPago == null || datosTotal.total <= 0}
              onClick={() => this.postMedioPago(auth.setcarritoProdctos)}
            >siguiente</button>
          </div>
          <ModalSinStock dadComponent={this} />
        </Container>
      </div>
    );
  }

  notificacion = async (alertTitulo = "", alertMensaje = "", alertOptions = null) => {
    this.setState({ alertTitulo, alertMensaje, alertOptions });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }

  postBuscarCarritoPedido = async (carritoProdctos, setcarritoProdctos) => {
    BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.datosLocal.localId, this.state.pedidoId)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          let productosSinStock = result.dto.repuestos.filter(t => !t.validaStok).length;
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;
          if (productosSinStock > 0) {
            this.setState({
              addStock: true,
              loading: false
            });
          } else {
            this.setState({
              loading: false,
              listaBancos: result.dto.listaBancos,
              productos: result.dto.repuestos,
              alertas: result.dto.alertas,
              locales: result.dto.perfil.locales,
              datosTotal: {
                total: _total,
                moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
              }
            })

            if (_total == 0)
              notificacion("Carrito", data.MensajeSinProducto);
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  postMedioPago = async (setcarritoProdctos) => {
    if (this.state.medioPago == data.MedioPago.Deposito) {
      // this.setState({ loading: true })
      // BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      //   this.state.datosLocal.localId, this.state.pedidoId)
      //   .then(result => {
      //     if (result.mo.type == "success") {
      //       this.setState({ loading: false })
      //       var dataSinStock = result.dto.repuestos.filter(x => !x.validaStok)
      //       if (dataSinStock.length == 0) {
      //         this.props.history.push({
      //           pathname: '/carrito-resumen-pedido',
      //           state: {
      //             datosTotal: this.state.datosTotal,
      //             localId: this.state.localId,
      //             pedidoId: this.state.pedidoId,
      //             datosLocal: this.state.datosLocal,
      //           }
      //         });
      //         setcarritoProdctos(0);
      //       } else {
      //         // this.notificacion("Aviso", "Alguno de tus productos ya no cuenta con stock.");
      //         this.setState({ addStock: true, loading: false }, () => {
      //           Alert.fire({
      //             // title: alertTitulo,
      //             html: "<p class='text-danger'>Alguno de tus productos<br><strong>ya no cuenta con stock</strong></p>",
      //             icon: 'warning',
      //             showCancelButton: false,
      //             confirmButtonColor: c.azul,
      //             confirmButtonText: 'Entendido'
      //           }).then((result) => {
      //             if (result.value) {
      //               this.props.history.push('/carrito');
      //             }
      //           })
      //         });
      //       }
      //     } else {
      //       throw new Error(result.mo.listMessage.join(", "));
      //     }
      //   }).catch((error) => {
      //     this.setState({ loading: false }, async () => {
      //       await this.notificacion("Carrito", error.message ?? null);
      //     });
      //   });

      this.props.history.push({
        pathname: 'resumen-pedido',
        state: {
          datosTotal: this.state.datosTotal,
          localId: this.state.localId,
          pedidoId: this.state.pedidoId,
          datosLocal: this.state.datosLocal,
          transportista: this.state.transportista
        }
      });

    } else if (this.state.medioPago == data.MedioPago.PrePedido) {
      this.postCrearPrePedido(setcarritoProdctos)
    }
  }


  postCrearPrePedido = async (setcarritoProdctos) => {
    this.setState({ loading: true })
    CrearPrePedido(this.state.dealer, this.state.linea, this.state.asociado, this.state.datosLocal.localId,
      this.state.transportista.transporte, this.state.transportista.contacto, this.state.transportista.recojo)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(0);
          this.setState({
            loading: false,
            datosTotal: {
              total: 0
            }
          }, async () => {
            notificacion("Aviso", "El pre-pedido se registró con éxito.", () => {
              this.toggleModalAlert();
              this.setState({ loading: false });
              // setrouterScreen({ from: data.Router.MedioPago, to: data.Router.PrePedidos });
              this.props.history.push('/pre-pedidos');
            });
          });
          // this.props.navigation.navigate('PrePedidos');
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
        this.setState({ loading: false }, async () => {
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
    // }
  }
  seleccionarMedioPago = (value) => {
    this.setState({ medioPago: value })
  }
}
